// import barba from '@barba/core';
// import gsap from 'gsap';
//
// export default function(routes) {
//   routes;
//
//   // Dissalow all WordPress Links (e.g. for adminbar)
//   function addDisallowedClass() {
//     $('a').each( function() {
//       if ( this.href.indexOf('/wp-admin/') !== -1 ||
//         this.href.indexOf('/wp-login.php') !== -1 ) {
//         $(this).addClass('no-barba').addClass('wp-link');
//       }
//     });
//   }
//
//   // Set disallowed links
//   addDisallowedClass();
//   barba.init({
//     prevent: ({ el }) => el.classList && el.classList.contains('no-barba'),
//     transitions: [{
//       name: 'opacity-transition',
//       leave(data) {
//         return gsap.to(data.current.container, {
//           opacity: 0,
//           duration: 0.8,
//           onComplete: () => {
//             this.async();
//             $('.navigation-wrapper').addClass('transitioning');
//           },
//         });
//       },
//       enter(data) {
//         $(window).scrollTop(0);
//         data.current.container.parentNode.removeChild(data.current.container);
//         return gsap.from(data.next.container, {
//           opacity: 0,
//           duration: 0.8,
//           onStart: () => {
//             $('body').attr('class', $('#body-classes').attr('class'));
//             addDisallowedClass();
//           },
//           onComplete: () => {
//             this.async();
//             $(document).scroll();
//
//             setTimeout(function(){
//               $('.navigation-wrapper').removeClass('transitioning');
//             }, 1500);
//
//             var element = document.querySelector('.ajax-load-more-wrap');
//             // eslint-disable-next-line
//             ajaxloadmore.start(element);
//
//             // eslint-disable-next-line
//             almfilters.start();
//           },
//         });
//       },
//     }],
//   });
// }



// WEBPACK FOOTER //
// ./scripts/barbainit.js